import React, {useState} from 'react';
import {
    AppBar,
    Breadcrumbs,
    Drawer,
    IconButton,
    Toolbar,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MenuIcon from '@mui/icons-material/Menu';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from './LocalizationProvider';
import Box from "@mui/material/Box";
import {Helmet} from "react-helmet";
import admixlogo from '../../resources/images/admixlogo.png';

const useStyles = makeStyles((theme) => ({
    desktopRoot: {
        height: '100%',
        display: 'flex',
    },
    mobileRoot: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    desktopDrawerPaper: {
        width: "100%",
        height: "80px",
        flexDirection: 'row',
        backgroundColor: "black",
        color: "#fafafa"
    },
    mobileDrawer: {
        width: theme.dimensions.drawerWidthTablet,
        flexDirection: 'column',
    },
    mobileToolbar: {
        zIndex: 1,
    },
    content: {
        flexGrow: 1,
        alignItems: 'stretch',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
    },
}));

const PageTitle = ({breadcrumbs}) => {
    const theme = useTheme();
    const t = useTranslation();

    const desktop = useMediaQuery(theme.breakpoints.up('md'));

    if (desktop) {
        return (
            <Typography variant="h6" noWrap>{t(breadcrumbs[0])}</Typography>
        );
    }
    return (
        <Breadcrumbs>
            {breadcrumbs.slice(0, -1).map((breadcrumb) => (
                <Typography variant="h6" color="inherit" key={breadcrumb}>{t(breadcrumb)}</Typography>
            ))}
            <Typography variant="h6" color="textPrimary">{t(breadcrumbs[breadcrumbs.length - 1])}</Typography>
        </Breadcrumbs>
    );
};

const PageLayout = ({menu, breadcrumbs, children}) => {
    const classes = useStyles();
    const theme = useTheme();
    const navigate = useNavigate();
    const t = useTranslation();
    const desktop = useMediaQuery(theme.breakpoints.up('md'));

    const [openDrawer, setOpenDrawer] = useState(false);

    return desktop ? (
        <div className={classes.desktopRoot}>
            <Helmet>
                <title>{t(breadcrumbs[0].toString())}</title>
            </Helmet>
            <Drawer
                variant="permanent"
                classes={{paper: classes.desktopDrawerPaper}}
            >
                <Toolbar>
                    <IconButton color="inherit" edge="start" sx={{mr: 2}} onClick={() => navigate('/')}>
                        <ArrowBackIcon/>
                    </IconButton>
                    <PageTitle breadcrumbs={breadcrumbs}/>
                    <Box
                        style={{cursor: "pointer", padding: "0 0 0 20px", height: "80px"}}
                        component="img"
                        sx={{
                            maxHeight: {xs: 233, md: 167},
                            maxWidth: {xs: 350, md: 250},
                        }}
                        alt="admix logo"
                        src={admixlogo}
                    />
                </Toolbar>
                {menu}
            </Drawer>
            <div style={{width: "100%"}}>
                <div className={classes.content}
                     style={{paddingTop: "80px", paddingBottom: "80px", minHeight: "100%"}}>{children}</div>
                <div style={{height: "52px", marginTop: "-60px", backgroundColor: "lightgrey"}}>
                    <hr style={{borderWidth: 1, color: "lightgray"}}/>
                    <center style={{fontSize: "0.9rem"}}>
                        © {new Date().getFullYear()} Admix Monitoring System
                    </center>
                </div>
            </div>
        </div>
    ) : (
        <div className={classes.mobileRoot}>
            <Drawer
                variant="temporary"
                open={openDrawer}
                onClose={() => setOpenDrawer(false)}
                classes={{paper: classes.mobileDrawer}}
            >
                <Toolbar>
                    <IconButton color="inherit" edge="start" sx={{mr: 2}} onClick={() => navigate('/')}>
                        <ArrowBackIcon/>
                    </IconButton>
                    <PageTitle breadcrumbs={breadcrumbs}/>
                </Toolbar>
                {menu}
            </Drawer>
            <AppBar className={classes.mobileToolbar} position="static" color="inherit">
                <Toolbar>
                    <IconButton color="inherit" edge="start" sx={{mr: 2}} onClick={() => setOpenDrawer(true)}>
                        <MenuIcon/>
                    </IconButton>
                    <PageTitle breadcrumbs={breadcrumbs}/>
                </Toolbar>
            </AppBar>
            <div className={classes.content}>{children}</div>
        </div>
    );
};

export default PageLayout;
